import { ReconstitutionCalculator } from "../components/ReconstitutionCalculator";
import { Seo } from "../components/Seo";

export default function CalculatorPage() {
  return (
    <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 py-16">
      <Seo title="Peptide Calculator" description="Free reconstitution calculator — work out concentration, draw volume and doses per vial for your research protocol." path="/calculator" />
      <div className="mb-10">
        <p className="text-xs tracking-[0.3em] uppercase font-semibold text-[#8C7B6B] mb-3">Research Tools</p>
        <h1 className="font-display text-xl sm:text-3xl uppercase tracking-wide text-[#1A1A1A]">Peptide Calculator</h1>
        <p className="text-base text-[#6E675F] mt-4 leading-relaxed">
          Enter your vial size, bacteriostatic water volume and target dose to calculate the concentration,
          syringe draw volume and total doses per vial.
        </p>
      </div>
      <ReconstitutionCalculator />
      <div className="mt-8 border border-[#DDD7CF] rounded-lg bg-white p-6" data-testid="calculator-help">
        <h2 className="font-display text-sm uppercase tracking-wide text-[#1A1A1A] mb-3">How it works</h2>
        <ol className="list-decimal pl-5 space-y-2 text-sm text-[#6E675F] leading-relaxed">
          <li><strong className="text-[#1A1A1A]">Peptide (mg)</strong> — the total amount of lyophilized peptide in your vial (e.g. 10 for a 10mg vial).</li>
          <li><strong className="text-[#1A1A1A]">Bac. Water (mL)</strong> — how much bacteriostatic water you add to the vial.</li>
          <li><strong className="text-[#1A1A1A]">Dose (mg or mcg)</strong> — the per-dose amount your protocol calls for. Use the mg / mcg switch under the field to enter it in whichever unit your protocol uses; the value converts automatically.</li>
        </ol>
      </div>
    </div>
  );
}
